module.exports = __webpack_public_path__ + "static/img/fish35.fadc769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish35.png
// module id = C1/m
// module chunks = 0